import { ShieldCheck, Award, BadgeCheck, Hash, Users } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const CREDENTIALS = [
  { icon: Award, label: "30 Years in Operation" },
  { icon: ShieldCheck, label: "Licensed Customs Broker" },
  { icon: BadgeCheck, label: "Jamaica Customs Agency Registered" },
  { icon: Users, label: "Member of The Custom Brokers & Freight Forwarders Association of Jamaica [CBFFAJ]" },
];

export const TrustBar = () => (
  <section className="py-16 lg:py-20 bg-cream-alt border-y border-ink/10" data-testid="trust-credentials-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-10">
      <Reveal>
        <div className="flex flex-wrap justify-center gap-x-10 gap-y-6">
          {CREDENTIALS.map((c) => {
            const Icon = c.icon;
            return (
              <div key={c.label} className="flex items-center gap-2.5" data-testid={`credential-${c.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <Icon size={18} className="text-gold-muted" />
                <span className="text-sm sm:text-base font-medium text-ink">{c.label}</span>
              </div>
            );
          })}
        </div>

        <div className="mt-8 flex flex-col items-center gap-2 text-center">
          <div
            data-testid="license-number-placeholder"
            className="flex items-center gap-2 text-sm text-ink-faint font-mono"
          >
            <Hash size={14} />
            Customs Broker License No. [LICENSE NUMBER] — Available upon request
          </div>
          <p className="text-sm text-ink-soft max-w-2xl mt-3">
            Fully compliant with Jamaica Customs Agency regulations, CARICOM trade rules, and
            destination-country import/export requirements.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
